import Vue from "vue";

// Components
import "./components";
import vuetify from "./plugins/vuetify";
// Application imports
import App from "./App";
import store from "@/store";
import Axios from "axios";
import Router from "vue-router";
import paths from "@/router/paths";

function route(path, view, name) {
    return {
        name: name || view,
        path,
        component: resolve => import(`@/views/${view}.vue`).then(resolve),
    };
}

Vue.use(Router);

// Create a new router
const router = new Router({
    mode: "history",
    routes: paths
        .map(path => route(path.path, path.view, path.name))
        .concat([{ path: "*", redirect: "/" }]),
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
export const eventBus = new Vue();

let bearerToken = JSON.parse(localStorage.getItem("token"));
if (bearerToken === null || bearerToken === undefined) {
    console.log("TOKEN", bearerToken);
    bearerToken = "";
    router.push("/login", () => {
        new Vue({
            router,
            store,
            vuetify,
            render: h => h(App),
        }).$mount("#app");
    });
}
let config = {
    headers: {
        Authorization: `Bearer ${bearerToken}`,
        "Content-Type": "application/json",
    },
};
Axios.post("https://cphl.esite-lab.com/api.php?do=checklogin", null, config)
    .then(response => {
        if (response.status === 200) {
            if (response.data.validity === true) {
                store.dispatch("setLogin");
                router.push("/home", () => {
                    new Vue({
                        router,
                        store,
                        vuetify,
                        render: h => h(App),
                    }).$mount("#app");
                });
            }
        }
    })
    .catch(err => {
        console.error("There is an error in the CheckLogin Endpoint: ", err);
        console.log("Pushing login");
        router.push("/login", () => {
            new Vue({
                router,
                store,
                vuetify,
                render: h => h(App),
            }).$mount("#app");
        });
    });
